import React, { forwardRef, ReactElement } from 'react'
import { DelayEditor } from './delay-editor'
import { SendNotificationEditor } from './send-notification-editor'
import {
    isDelayJourneyNode,
    isSendCartNotificationNode,
    isSendNotificationNode,
    isSendRecommendedNotificationNode,
    isSendSavedItemNotificationActionStep,
    isSendSavedItemNotificationNode,
    isSendViewedItemNotificationNode,
    JourneyNode,
    NodeEditorRef,
} from '../types/journey-nodes'
import { SendRecommendedNotificationEditor } from './send-recommended-notification-editor/send-recommended-notification-editor'

type NodeEditorProps = {
    node: JourneyNode
}

export const NodeEditor = forwardRef<NodeEditorRef, NodeEditorProps>(({ node }, ref) => {
    let editor: ReactElement | null

    if (!node) {
        return null
    }

    if (isDelayJourneyNode(node)) {
        editor = <DelayEditor node={node} ref={ref} />
    } else if (
        isSendNotificationNode(node)
        || isSendCartNotificationNode(node)
        || isSendViewedItemNotificationNode(node)
        || isSendSavedItemNotificationNode(node)
    ) {
        editor = <SendNotificationEditor node={node} ref={ref} />
    } else if (isSendRecommendedNotificationNode(node)) {
        editor = <SendRecommendedNotificationEditor node={node} ref={ref} />
    } else {
        editor = null
    }

    return editor
})
